import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "./constants";

export const categoryService = createApi({
    reducerPath: "categoryService",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("admin")
                ? JSON.parse(localStorage.getItem("admin")).token
                : null;
            if (token) headers.set("Authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ["Categories"],  // Tag type for cache invalidation
    endpoints: (builder) => ({
        fetchCategories: builder.query({
            query: () => "admin/ad-categories",
            providesTags: (result) =>
                result ? [{ type: "Categories", id: "LIST" }] : [],
        }),

        addCategory: builder.mutation({
            query: (formData) => ({
                url: "admin/ad-categories",
                method: "POST",
                body: formData,
            }),
            invalidatesTags: [{ type: "Categories", id: "LIST" }],
        }),

        editCategory: builder.mutation({
            query: ({ formData }) => ({
                url: `admin/ad-categories`, // PUT request for editing category
                method: "POST",
                body: formData,
            }),
            invalidatesTags: [{ type: "Categories", id: "LIST" }],
        }),

        deleteCategory: builder.mutation({
            query: (id) => ({
              url: `admin/ad-categories/${id}`, // Delete endpoint
              method: "DELETE",
            }),
            invalidatesTags: [{ type: "Categories", id: "LIST" }], // Invalidate customer list to refresh data
          }),


    }),
});

export const { useFetchCategoriesQuery, useAddCategoryMutation, useEditCategoryMutation,useDeleteCategoryMutation } = categoryService;
